export enum ToastDuration {
  Short = 3000,
  Medium = 5000,
  Long = 10000,
}
